"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SbpBig = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SbpBig = function SbpBig(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 56,
    height: 28,
    viewBox: "0 0 56 28",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M49.163 10.385v6.312h-2.13v-4.43h-2.05v4.43h-2.13v-6.312h6.31zm-7.316 3.518c0 1.835-1.465 3.049-3.439 3.049-2.043 0-3.529-1.283-3.529-4.194 0-2.495 1.526-4.552 3.787-4.588.988 0 3.114-.05 3.114-.05l-.957 1.836h-1.918a1.961 1.961 0 00-1.316.52 2.128 2.128 0 00-.668 1.293 2.836 2.836 0 012.04-.8c1.8.003 2.886 1.156 2.886 2.934zm-2.186 0c0-.824-.509-1.307-1.24-1.307-.758 0-1.262.494-1.262 1.318 0 .777.507 1.343 1.262 1.343.784 0 1.236-.612 1.236-1.354h.004zm-6.472.887c-.4.21-.837.333-1.285.361-.883.027-1.666-.54-1.666-1.553s.697-1.554 1.65-1.554c.584 0 1.363.415 1.363.415s.566-1.062.859-1.592a3.35 3.35 0 00-2.093-.64c-2.1 0-3.725 1.398-3.725 3.361 0 1.989 1.528 3.354 3.724 3.313.616-.024 1.464-.244 1.979-.582l-.806-1.528z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.038 6.507l2.943 5.477v3.338l-2.939 5.466-.004-14.28z",
    fill: "#656CAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.335 9.99l2.759-1.758 5.64-.005-8.399 5.358V9.991z",
    fill: "#C25169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.32 6.475l.015 7.25-2.949-1.886V1l2.934 5.475z",
    fill: "#EBAD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.734 8.227l-5.64.005-2.774-1.757L14.386 1l11.348 7.227z",
    fill: "#DB754B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.335 20.82V17.3l-2.949-1.85.002 10.85 2.947-5.481z",
    fill: "#81BB5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.086 19.076L8.98 11.984 6.038 6.507 25.723 19.07l-5.637.006z",
    fill: "#608BC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.388 26.3l2.947-5.48 2.75-1.744 5.638-.006-11.335 7.23z",
    fill: "#548254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.042 20.788l8.367-5.338-2.813-1.797-2.616 1.67-2.938 5.465z",
    fill: "#8366A8"
  }));
};

exports.SbpBig = SbpBig;
var _default = SbpBig;
exports.default = _default;